import { apiGet } from "./client";

export interface AdminDashboardSummary {
  totalWorkspaces: number;
  activeWorkspaces7d: number;
  activeWorkspaces30d: number;
  newWorkspacesInPeriod: number;
  humanUsers: number;
  unverifiedUsers: number;
  ordersInPeriod: number;
  invoicesInPeriod: number;
  connectedAccountingIntegrations: number;
  activeMcpTokens: number;
  attentionCount: number;
}

export interface AdminWorkspaceSummary {
  id: string;
  name: string;
  owner: string;
  companyNames: string[];
  companyCount: number;
  ordersInPeriod: number;
  createdAt: string | null;
  lastActivityAt: string | null;
}

export interface AdminAttentionItem {
  type: string;
  severity: "warning" | "error";
  workspaceId: string | null;
  workspaceName: string | null;
  title: string;
  detail: string;
  occurredAt: string | null;
}

export interface AdminDailyOrderActivity {
  date: string;
  orderCount: number;
}

export interface AdminCompanyOrderVolume {
  companyId: string | null;
  companyName: string;
  workspaceId: string | null;
  workspaceName: string | null;
  orderCount: number;
}

export interface AdminDashboardData {
  generatedAt: string;
  periodDays: number;
  backfilledWorkspaceCount: number;
  summary: AdminDashboardSummary;
  orderStatusCounts: Record<string, number>;
  settlementStatusCounts: Record<string, number>;
  dailyOrderActivity: AdminDailyOrderActivity[];
  orderVolumeByCompany: AdminCompanyOrderVolume[];
  orderCompanyAttribution: {
    resolved: number;
    unresolved: number;
  };
  recentWorkspaces: AdminWorkspaceSummary[];
  workspaces: AdminWorkspaceSummary[];
  attentionItems: AdminAttentionItem[];
}

export const getAdminDashboard = async (
  token: string,
  periodDays = 30,
): Promise<AdminDashboardData> => {
  const response = await apiGet(
    token,
    `/api/admin/dashboard?period=${periodDays}`,
  );
  return response?.data ?? response;
};
